import { render } from "./Technologies.vue?vue&type=template&id=5e96785b"
import script from "./Technologies.vue?vue&type=script&lang=js"
export * from "./Technologies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__